import { createTheme, adaptV4Theme } from "@mui/material/styles";
import { UIStyleConstants } from "../rule-engine-core/Common/UIStyleConstants";

export const theme = createTheme(
    adaptV4Theme({
        typography: {
            fontFamily: UIStyleConstants.FONT_FAMILY,
        },
        palette: {
            primary: {
                main: UIStyleConstants.PRIMARY_COLOR,
                light: UIStyleConstants.GRAY_VERY_LIGHT_COLOR,
                dark: UIStyleConstants.GRAY_DARK_COLOR,
            },
            success: {
                main: UIStyleConstants.PRIMARY_COLOR,
                light: UIStyleConstants.GRAY_LIGHT_COLOR,
                dark: UIStyleConstants.PRIMARY_COLOR,
            },
            error: {
                main: UIStyleConstants.RED_DARK_COLOR,
                light: UIStyleConstants.RED_LIGHT_COLOR,
                dark: UIStyleConstants.RED_DARK_COLOR,
            },
            text: {
                primary: UIStyleConstants.GRAY_DARK_COLOR,
                secondary: UIStyleConstants.GRAY_COLOR,
                disabled: UIStyleConstants.GRAY_LIGHT_COLOR,
            },
        },

        overrides: {
            MuiOutlinedInput: {
                root: {
                    fontSize: "14px",
                    color: UIStyleConstants.GRAY_DARK_COLOR,
                },
            },
            MuiInputLabel: {
                root: {
                    fontSize: "14px",
                    color: UIStyleConstants.GRAY_DARK_COLOR,
                    fontWeight: 600,
                },
            },
            MuiIconButton: {
                root: {
                    color: UIStyleConstants.PRIMARY_COLOR,
                },
            },
        },
    }),
);
